import React from 'react'
import clsx from 'clsx'

type BadgeVariant = 'green' | 'yellow' | 'red' | 'blue' | 'gray' | 'primary' | 'amber'

interface BadgeProps {
  variant?: BadgeVariant
  children: React.ReactNode
  className?: string
  onClick?: () => void
}

const variantStyles: Record<BadgeVariant, string> = {
  green: 'bg-green-100 text-green-700',
  yellow: 'bg-yellow-100 text-yellow-700',
  red: 'bg-red-100 text-red-700',
  blue: 'bg-blue-100 text-blue-700',
  gray: 'bg-gray-100 text-text-secondary',
  primary: 'bg-primary/10 text-primary',
  amber: 'bg-amber-100 text-amber-700',
}

export default function Badge({ variant = 'gray', children, className, onClick }: BadgeProps) {
  return (
    <span
      onClick={onClick}
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold',
        variantStyles[variant],
        className
      )}
    >
      {children}
    </span>
  )
}
